export default __webpack_public_path__ + "static/media/cvod-R15.9ef146a2.svg";